import React from 'react';
import AuthForm from '../components/AuthForm';

export default function RegisterPage() {
  return <AuthForm mode="register" />;
}
